import React, { Component } from 'react';
import { Table } from "reactstrap";
import './Products.css'
import { BarChart2, Trash } from "react-feather";
import { Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Moment from "moment";
import AddEventCaptureModal from "./modals/AddEventCaptureModal";
import EventCaptureRoiModal from "./modals/EventCaptureRoiModal";
import { apiFetch, API } from "../services/api";

function getEventCaptures() {
    return apiFetch(API.back + '/event-captures', { method: 'GET' })
        .then(data => data.json())
        .catch(err => console.log(err));
}

function deleteEventCapture(event) {
    return apiFetch(API.back + '/event-capture', {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(event),
    }).catch(err => console.log(err));
}

export class EventCapturesList extends Component {
    state = {
        events: null,
        errors: null,
        isOpen: false,
        isRoi: false,
        selectedEvent: { name: "" },
    };

    async componentDidMount() {
        await getEventCaptures().then(data => {
            this.setState({ events: Array.isArray(data) ? data : [] });
        }).catch(() => this.setState({ errors: "error while getting event captures" }));
    }

    closeModal = () => this.setState({ isOpen: false, isRoi: false, selectedEvent: { name: "" } });

    handleDelete = (event) => {
        if (!window.confirm(`Supprimer l'évènement "${event.name}" ?`)) return;
        deleteEventCapture(event).then(() => {
            setTimeout(() => window.location.reload(false), 1000);
        });
    };

    render() {
        const { events, errors } = this.state;
        return (
            <div className="products-list">
                <Row>
                    <Col sm={12} className="products-buttons">
                        <Button className="add-product-button" variant="secondary"
                                onClick={() => this.setState({ isOpen: true, selectedEvent: { name: "" } })}>
                            Ajouter un évènement de captation
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} className="products-buttons">
                        {events && events.length > 0 && errors == null
                            ? <span>{events.length} évènement{events.length === 1 ? "" : "s"}</span>
                            : null}
                    </Col>
                </Row>

                {errors != null ? <p>Erreur lors de la récupération des évènements, veuillez vous reconnecter</p> : null}

                {(!events && errors == null) ? <p>Chargement ...</p> :
                    <Table responsive>
                        <thead>
                        <th>Nom</th>
                        <th>Slug</th>
                        <th>Date</th>
                        <th>Coût</th>
                        <th>QR code</th>
                        <th>Actif</th>
                        <th>ROI</th>
                        <th></th>
                        </thead>
                        <tbody>
                        {events && events.map(event => (
                            <tr key={event.id}>
                                <td>{event.name}</td>
                                <td><code>{event.slug}</code></td>
                                <td>{event.date ? Moment(event.date).format("DD/MM/YYYY") : "—"}</td>
                                <td>{(Number(event.cost) || 0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })}</td>
                                <td>
                                    {event.QRCode ? (
                                        <a href={event.QRCode} target="_blank" rel="noreferrer">
                                            <img src={event.QRCode} alt="QR" style={{ width: 48, height: 48 }} />
                                        </a>
                                    ) : "—"}
                                </td>
                                <td>{event.active ? "✅" : "❌"}</td>
                                <OverlayTrigger placement="top" overlay={<Tooltip>Voir le ROI</Tooltip>}>
                                    <td className="table-action" style={{ cursor: "pointer" }}>
                                        <BarChart2 size={18} onClick={() => this.setState({ isRoi: true, selectedEvent: event })} />
                                    </td>
                                </OverlayTrigger>
                                <OverlayTrigger placement="top" overlay={<Tooltip>Supprimer</Tooltip>}>
                                    <td className="table-action" style={{ cursor: "pointer" }}>
                                        <Trash size={18} onClick={() => this.handleDelete(event)} />
                                    </td>
                                </OverlayTrigger>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                }

                {this.state.isOpen ?
                    <AddEventCaptureModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isOpen}
                        selectedEvent={this.state.selectedEvent}
                    /> : null}

                {this.state.isRoi ?
                    <EventCaptureRoiModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isRoi}
                        selectedEvent={this.state.selectedEvent}
                    /> : null}
            </div>
        );
    }
}
